var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUk(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30 30"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "uk_svg__a",
    cx: 15,
    cy: 15,
    r: 15
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "uk_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#uk_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#uk_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#uk_svg__b)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 15,
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M3.101 5.868a14.943 14.943 0 00-2.584 5.22H8.32l-5.219-5.22zm26.383 5.219a14.94 14.94 0 00-2.585-5.219l-5.219 5.22h7.804zM.517 18.913a14.943 14.943 0 002.584 5.22l5.22-5.22H.516zM24.133 3.101a14.943 14.943 0 00-5.22-2.584V8.32l5.22-5.219zM5.868 26.899a14.945 14.945 0 005.22 2.585v-7.805l-5.22 5.22zM11.087.517a14.951 14.951 0 00-5.22 2.584l5.22 5.22V.516zm7.826 28.967a14.945 14.945 0 005.22-2.585l-5.22-5.219v7.804zm2.767-10.571l5.22 5.22a14.96 14.96 0 002.584-5.22h-7.805z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.873 13.043H16.957V.127a15.22 15.22 0 00-3.914 0v12.916H.127a15.22 15.22 0 000 3.914h12.916v12.916a15.22 15.22 0 003.914 0V16.957h12.916a15.22 15.22 0 000-3.914z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.913 18.913l6.694 6.694c.307-.308.601-.63.881-.963l-5.73-5.73h-1.845zm-7.826 0l-6.694 6.694c.308.307.63.601.963.881l5.73-5.73v-1.845zm0-7.826L4.393 4.393c-.307.308-.601.63-.881.963l5.73 5.731h1.845zm7.826 0l6.694-6.694a15.44 15.44 0 00-.963-.881l-5.73 5.73v1.845z"
  }))))));
}

export default SvgUk;